module.exports = __webpack_public_path__ + "img/button_Symposium.caa15b5f.svg";